import { useEffect, useState } from "react";
import {
    blackFade,
    blueFadeColor,
    redFade,
    stoneColdGrayColor,
    strongRedColor,
    white,
    yellowishWhite
} from "../../config/ColorObj";

const SystemInterruptionAlert = ({ isOpen = true, paymentObject, onClose }) => {
    const [seconds, setSeconds] = useState(paymentObject.timeInSeconds);
    const [showLater, setShowLater] = useState(false);

    useEffect(() => {
        if (!isOpen) return;

        if (seconds <= 0) {
            setShowLater(true);
            return;
        }

        const timer = setInterval(() => {
            setSeconds((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [seconds, isOpen]);

    if (!isOpen) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.card}>
                {/* Top Header Section */}
                <div style={{ ...styles.iconArea, background: paymentObject.color3 }}>
                    <div style={styles.lock}>
                        <div
                            style={{
                                ...styles.lockBefore,
                                border: `10px solid ${paymentObject.color2}`,
                            }}
                        ></div>
                        <div
                            style={{ ...styles.lockBody, background: paymentObject.color2 }}
                        ></div>
                    </div>
                </div>

                {/* Content */}
                <div style={styles.content}>
                    <div style={styles.title}>{paymentObject.title}</div>

                    {/* Amount Section */}

                    <div style={styles.dueInfo}>
                        <div style={styles.daysLeft}>
                            {paymentObject.currentDays} days{" "}
                            {paymentObject.stage == 0 ? "left" : "overdue"}
                        </div>
                        <div>
                            {paymentObject.stage == 0
                                ? "Subscription End Date"
                                : "Your Subscription Ended On"}{" "}
                            {paymentObject.billingDate || " "}
                        </div>
                    </div>

                    {/* Account Details */}
                    <div style={styles.section}>
                        <div style={styles.sectionTitle}>{paymentObject.description1}</div>
                    </div>

                    {/* Support Info */}
                    <div style={styles.support}>
                        In case you processed payment and still facing interruption then
                        please connect on{" "}
                        <span style={styles.connectDetails}>{paymentObject.emailId} </span>{" "}
                        |{" "}
                        <span style={styles.connectDetails}>
                            {paymentObject.contactNumber}
                        </span>
                    </div>

                    {/* Footer Action */}
                    <div style={styles.footerAction}>
                        {!showLater ? (
                            <span style={styles.countdown}>
                                I'll do it later ({seconds}s)
                            </span>
                        ) : paymentObject.isFinal == 0 ? (
                            <span style={styles.later} onClick={() => onClose && onClose()}>
                                I'll do it later
                            </span>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ================= STYLES ================= */

const styles = {
    overlay: {
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
    },
    card: {
        width: "520px",
        background: white,
        borderRadius: "16px",
        boxShadow: "0 25px 60px rgba(0,0,0,0.25)",
        overflow: "hidden",
        textAlign: "center",
    },
    iconArea: {
        padding: "36px 0 30px",
    },
    lock: {
        width: "80px",
        height: "85px",
        margin: "0 auto",
        position: "relative",
    },
    lockBefore: {
        position: "absolute",
        top: 0,
        left: "50%",
        transform: "translateX(-50%)",
        width: "50px",
        height: "40px",
        borderBottom: "none",
        borderRadius: "28px 28px 0 0",
        boxSizing: "border-box",
    },
    lockBody: {
        position: "absolute",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        width: "65px",
        height: "55px",
        borderRadius: "10px",
    },
    content: {
        padding: "32px 40px",
        textAlign: "left",
    },
    title: {
        fontSize: "21px",
        fontWeight: 700,
        marginBottom: "12px",
        textAlign: "center",
    },
    amount: {
        fontSize: "32px",
        fontWeight: 800,
        color: strongRedColor,
        textAlign: "center",
        marginBottom: "8px",
    },
    dueInfo: {
        textAlign: "center",
        fontSize: "14px",
        marginBottom: "24px",
        lineHeight: "1.6",
    },
    daysLeft: {
        color: redFade,
        fontWeight: 600,
        fontSize: "20px",
    },
    section: {
        marginBottom: "70px",
        textAlign: "center",
    },
    sectionTitle: {
        fontSize: "14px",
        marginBottom: "10px",
    },
    detailRow: {
        display: "flex",
        justifyContent: "space-between",
        fontSize: "14px",
        marginBottom: "6px",
        color: blackFade,
    },
    paymentMethods: {
        display: "flex",
        gap: "10px",
    },
    methodBtn: {
        flex: 1,
        padding: "8px",
        border: "1px solid #ddd",
        borderRadius: "6px",
        textAlign: "center",
        cursor: "pointer",
        fontSize: "14px",
    },
    activeMethod: {
        border: `1px solid ${strongRedColor}`,
        background: yellowishWhite,
        fontWeight: 600,
    },
    payBtn: {
        width: "100%",
        marginTop: "10px",
        background: strongRedColor,
        border: "none",
        color: white,
        fontSize: "16px",
        fontWeight: 700,
        padding: "14px",
        borderRadius: "8px",
        cursor: "pointer",
    },
    support: {
        fontSize: "12px",
        color: stoneColdGrayColor,
        marginTop: "14px",
        textAlign: "center",
    },
    footerAction: {
        marginTop: "20px",
        fontSize: "14px",
        textAlign: "center",
    },
    countdown: {
        fontWeight: 700,
        color: strongRedColor,
    },
    later: {
        textDecoration: "underline",
        cursor: "pointer",
    },
    connectDetails: {
        color: blueFadeColor,
    },
};

export default SystemInterruptionAlert;
